import { useState, useCallback, useEffect } from "react";
import { useLanguage } from "../i18n/LanguageContext";
import "./TeacherGallery.css";

const photoFiles = [
  "Image_20260407110946_118_34.jpg",
  "Image_20260407110948_119_34.jpg",
  "Image_20260407110951_120_34.jpg",
  "Image_20260407110956_121_34.jpg",
  "Image_20260407111002_123_34.jpg",
  "Image_20260407114853_130_34.jpg",
  "Image_20260407114856_131_34.jpg",
  "Image_20260407114908_134_34.jpg",
  "Image_20260407114914_135_34.jpg",
  "Image_20260407114923_136_34.jpg",
  "Image_20260407114932_137_34.jpg",
  "Image_20260407115259_139_34.jpg",
  "Image_20260407115309_140_34.jpg",
  "Image_20260407115314_141_34.jpg",
  "Image_20260407115325_144_34.jpg",
  "Image_20260407115336_147_34.jpg",
  "Image_20260407115344_150_34.jpg",
  "Image_20260407115348_151_34.jpg",
  "Image_20260407115349_152_34.jpg",
  "Image_20260407115351_154_34.jpg",
  "Image_20260407115354_156_34.jpg",
  "Image_20260407115406_160_34.jpg",
];

function Lightbox({ src, onClose }) {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [onClose]);

  return (
    <div className="lightbox-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <button className="lightbox-close" onClick={onClose} aria-label="Close">
        &times;
      </button>
      <img
        src={src}
        alt=""
        className="lightbox-image"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}

export default function TeacherGallery() {
  const { t } = useLanguage();
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  const openPhoto = useCallback((src) => setSelectedPhoto(src), []);
  const closePhoto = useCallback(() => setSelectedPhoto(null), []);

  return (
    <section id="teacher-gallery" className="teacher-gallery-section" aria-label="Teacher Gallery">
      <div className="section-header">
        <h2 className="section-title">{t.teacherGallery.sectionTitle}</h2>
        <div className="section-divider" aria-hidden="true">
          <span className="divider-dot" />
          <span className="divider-line" />
          <span className="divider-dot" />
        </div>
      </div>
      <div className="gallery-grid">
        {photoFiles.map((file) => {
          const src = require(`../assets/teacher_pics/${file}`);
          return (
            <button
              key={file}
              className="gallery-thumb-btn"
              onClick={() => openPhoto(src)}
              aria-label={t.teacherGallery.viewPhoto}
            >
              <img src={src} alt="" className="gallery-thumb" loading="lazy" />
            </button>
          );
        })}
      </div>
      {selectedPhoto && <Lightbox src={selectedPhoto} onClose={closePhoto} />}
    </section>
  );
}
